export default "__VITE_ASSET__BKDX0YvT__"